import React from "react";

import NotificationRow from "./NotificationRow";
import {
  NotificationListSkeleton,
  NotificationRowSkeleton,
} from "./NotificationSkeletons";
import {
  NOTIFICATIONS_COPY,
  NOTIFICATIONS_EMPTY,
  NOTIFICATIONS_ERROR,
} from "../notificationsCopy";

const StateView = ({ heading, body, actionLabel, onAction }) => (
  <div className="nt-state">
    <svg
      className="nt-state-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 8.5a6 6 0 10-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5z" />
      <path d="M13.7 18.5a2 2 0 01-3.4 0" />
    </svg>

    <h3>{heading}</h3>
    <p>{body}</p>

    {onAction && (
      <button type="button" className="nt-btn nt-btn-outline" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

const NotificationsPanel = ({ inbox, skeletonRows = 4 }) => {
  const failure = inbox.errorKind
    ? NOTIFICATIONS_ERROR[inbox.errorKind] || NOTIFICATIONS_ERROR.network
    : null;

  if (inbox.showSkeleton) return <NotificationListSkeleton rows={skeletonRows} />;

  if (failure) {
    return (
      <StateView
        heading={failure.heading}
        body={failure.body}
        actionLabel={NOTIFICATIONS_COPY.retry}
        onAction={inbox.refresh}
      />
    );
  }

  if (!inbox.hasRows) {
    return (
      <StateView
        heading={NOTIFICATIONS_EMPTY.heading}
        body={NOTIFICATIONS_EMPTY.body}
      />
    );
  }

  return (
    <>
      {inbox.sections.map((section) => (
        <section className="nt-section" key={section.title}>
          <h3 className="nt-day">{section.title}</h3>

          <ul className="nt-list">
            {section.items.map((item) => (
              <NotificationRow
                key={item.id}
                item={item}
                marking={inbox.markingId === item.id}
                disabled={Boolean(inbox.markingId) || inbox.markingAll}
                onOpen={inbox.open}
              />
            ))}
          </ul>
        </section>
      ))}

      {inbox.paginating && (
        <ul className="nt-list nt-list-more">
          <NotificationRowSkeleton />
        </ul>
      )}

      {!inbox.isLast && !inbox.paginating && (
        <div className="nt-more">
          <button
            type="button"
            className="nt-btn nt-btn-outline"
            onClick={inbox.blockedByError ? inbox.refresh : inbox.loadMore}
          >
            {inbox.blockedByError
              ? NOTIFICATIONS_COPY.retry
              : NOTIFICATIONS_COPY.loadMore}
          </button>
        </div>
      )}
    </>
  );
};

export const NotificationsSummary = ({ inbox }) => {
  if (inbox.unreadCount <= 0) return null;

  return (
    <div className="nt-summary">
      <span className="nt-pill">
        <i />
        {NOTIFICATIONS_COPY.unread(inbox.unreadLabel)}
      </span>

      <button
        type="button"
        className="nt-mark-all"
        onClick={inbox.markAllRead}
        disabled={inbox.markingAll}
      >
        {NOTIFICATIONS_COPY.markAll}
      </button>
    </div>
  );
};

export default NotificationsPanel;
